import { hiddenDate } from '../pages/Case/helpers/hiddenDots';

export const formatDateOrHidden = (date: string, canView: boolean) => {
  if (!canView) return hiddenDate;

  return date;
};
